import { render, staticRenderFns } from "./wantgrid.vue?vue&type=template&id=0355da38&scoped=true&"
import script from "./wantgrid.vue?vue&type=script&lang=js&"
export * from "./wantgrid.vue?vue&type=script&lang=js&"
import style0 from "./wantgrid.vue?vue&type=style&index=0&id=0355da38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355da38",
  null
  
)

export default component.exports